module.exports = __webpack_public_path__ + "img/fruit_cherry.b99db106.png";